import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts'
import { TooltipBox } from './AIChartParts'
import { GRID, AXIS_TEXT, usd, num, axisUsd } from './aiCostFormat'

/**
 * Horizontal cost bars for a breakdown (provider / model / feature).
 * rows: [{ label, cost, requests, color, extra? }]
 */
const AIHorizontalBars = ({ rows }) => {
  const height = Math.max(120, rows.length * 34 + 40)

  const RowTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null
    const r = payload[0].payload
    return (
      <TooltipBox
        title={r.label}
        rows={[
          { label: 'Cost', value: usd(r.cost), color: r.color },
          { label: 'Requests', value: num(r.requests) },
          { label: 'Avg / request', value: usd(r.requests ? r.cost / r.requests : 0) },
          ...(r.extra || []),
        ]}
      />
    )
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={rows} layout="vertical" margin={{ top: 4, right: 16, left: 0, bottom: 0 }} barCategoryGap="25%">
        <CartesianGrid horizontal={false} stroke={GRID} />
        <XAxis type="number" tickFormatter={axisUsd} tick={{ fill: AXIS_TEXT, fontSize: 12 }} axisLine={false} tickLine={false} />
        <YAxis type="category" dataKey="label" width={150} tick={{ fill: AXIS_TEXT, fontSize: 12 }} axisLine={false} tickLine={false} />
        <Tooltip cursor={{ fill: 'rgba(0,0,0,0.04)' }} content={<RowTooltip />} />
        <Bar dataKey="cost" radius={[0, 4, 4, 0]} maxBarSize={22}>
          {rows.map((r) => (
            <Cell key={r.label} fill={r.color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}

export default AIHorizontalBars
